import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

export interface ConfirmDialogData {
  title?: string;
  message?: string;
  details?: string[];
  type?: 'warning' | 'danger' | 'info';
  confirmText?: string;
  cancelText?: string;
  showDetails?: boolean;
}

@Component({
  selector: 'app-confirm',
  templateUrl: './confirm.component.html',
  styleUrls: ['./confirm.component.scss']
})
export class ConfirmComponent implements OnInit {
  
  public title: string;
  public message: string;
  public details: string[];
  public type: string;
  public confirmText: string;
  public cancelText: string;
  public showDetails: boolean;

  constructor(
    private _dialogRef: MatDialogRef<ConfirmComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData
  ) {
    // Set default values or use provided data
    this.title = (data && data.title) || 'Are you sure want to delete the record?';
    this.message = (data && data.message) || 'This record will be permanently deleted. You cannot recover it in near future.';
    this.details = (data && data.details) || [];
    this.type = (data && data.type) || 'danger';
    this.confirmText = (data && data.confirmText) || 'Proceed';
    this.cancelText = (data && data.cancelText) || 'Cancel';
    this.showDetails = (data && data.showDetails) || false;
  }

  ngOnInit() {
  }

  public onClose(response?: boolean){
    this._dialogRef.close(response);
  }

}
